/**
 * Frozen, indexed view over the keyboard schema.
 *
 * Built once at module load from `keybindings`. Pure module state with no React
 * coupling, so handlers can read it synchronously at event time without creating
 * any subscription or re-render — the invariant that keeps `useKeyboardNavigation`
 * on its zero-rerender hot path.
 */

import { keybindings } from './keybindings';
import type { KbdContext, Keybinding, KeybindingId } from './keybinding.types';

const byIdMap = new Map<KeybindingId, Keybinding>(keybindings.map((b) => [b.id, b]));

const byContextMap = new Map<KbdContext, Keybinding[]>();
for (const b of keybindings) {
  const existing = byContextMap.get(b.context) ?? [];
  existing.push(b);
  byContextMap.set(b.context, existing);
}

export const keybindingRegistry = Object.freeze({
  byId: (id: KeybindingId): Keybinding | undefined => byIdMap.get(id),
  byContext: (context: KbdContext): Keybinding[] => byContextMap.get(context) ?? [],
  all: (): Keybinding[] => keybindings,
});
